import type {
    ComposableOptionsBase,
    Shipment
} from '~/types';
import type {
    PaginatedPayload,
    CustomPagination,
    PaginatedRequest
} from 'x1-base/types';

import { merge as lo_mergeCompat } from 'es-toolkit/compat';
import { omit as lo_omit } from 'es-toolkit';

import type { NitroFetchOptions } from 'nitropack';
import { useApiUtils } from 'x1-base/composables';
import { useCustomFetch } from '~/composables';

export interface UseShipmentsOptions extends ComposableOptionsBase {}

export function useShipments(options: Partial<UseShipmentsOptions> = {}) {
    const apiBasePath = '/v1/shipments';
    const useApiUtilsObj = useApiUtils();
    const $_fetch = useCustomFetch({ siteContext: options.siteContext });

    async function getItems(
        args: PaginatedRequest = {},
        query: NitroFetchOptions<string>['query'] = {}
    ): Promise<PaginatedPayload<Shipment> | Error> {
        const url = args?.url ?? `${apiBasePath}/`;

        const config: NitroFetchOptions<string> = {
            method: 'GET',
            query: {}
        };

        lo_mergeCompat(config.query, args?.params, query);

        try {
            const response = await $_fetch<CustomPagination<Shipment>>(url, config);

            return {
                pagination: lo_omit(response, ['results']),
                data: response.results
            };
        } catch (err) {
            return useApiUtilsObj.getErrorObj(err);
        }
    }

    async function getItem(uid: string, expand: string[] = []): Promise<Shipment | Error> {
        const url = `${apiBasePath}/${uid}/`;
        const config: NitroFetchOptions<string> = {
            method: 'GET',
            query: { expand: expand.join(',') }
        };

        try {
            return await $_fetch<Shipment>(url, config);
        } catch (err) {
            return useApiUtilsObj.getErrorObj(err);
        }
    }

    return {
        getItems,
        getItem
    };
}
